/**
 * RETAIL PRODUCT FINDER MODULE
 * Self-contained. Import only from /shared or within this module.
 * Do not import from other modules directly.
 */

import RetailProductFinderPage from "../components/RetailProductFinderPage.jsx";

// Retail Product Finder — the "where to buy" store list behind the public
// finder. Registered with roles: ['workspace_admin'], so the route guard already
// restricts this to the tenant's owner/admin; canEdit stays true here and the
// prop exists for the day a read-only viewer role lands.
export default function RetailFinder() {
  return <RetailProductFinderPage canEdit />;
}
